(function (angular) {
    'use strict';

    angular.module('forms')

        .controller("formsModal", ["$uibModalInstance", "WizardHandler", "form", "formsTemplates", "$sce", "portalConfig", "$stateParams", "$sanitize", "$scope",
            function ($uibModalInstance, WizardHandler, form, formsTemplates, $sce, portalConfig, $stateParams, $sanitize, $scope) {

                var vm = this;
                vm.wizardTitle = "Create or update a template";
                vm.form = form;
                vm.formsTemplates = formsTemplates;
                vm.updating = false;
                vm.errorMessage = {};
                vm.dropdownLabel = "Choose a form";
                vm.resources = {};
                var apiSpaceId = $stateParams.pickedApiSpaceId;
                var formUrlBase = portalConfig.formUrlBase;
                vm.cancel = function () {
                    WizardHandler.wizard("formsWizard").cancel();
                    $uibModalInstance.dismiss();
                }

                vm.chooseTemplate = function (template) {
                    vm.pickedTemplate = template;
                    vm.newForm.templateId = template.id;
                    vm.customisations = vm.pickedTemplate.customisations;

                    for (const key in vm.pickedTemplate.customisations) {
                        let value = vm.customisations[key];
                        vm.resources[key] = value.default;
                    }
                    vm.dropdownLabel = vm.pickedTemplate.name;
                    vm.createPreview();
                }

                vm.createPreview = function () {
                    var encoded = encodeURIComponent(JSON.stringify(vm.resources));
                    var myUrl = `${formUrlBase}/${apiSpaceId}/forms/${vm.newForm.templateId}/preview?resources=${encoded}`;

                    vm.previewUrl = $sce.trustAsResourceUrl(myUrl);
                }

                $scope.$watch(function () {
                    return vm.resources;
                }, function (newVal, oldVal) {
                    let index = 0;
                    for (let val in newVal) {
                        vm.validateValue(newVal[val], index);
                        index++;
                    }

                }, true);

                vm.validateValue = function (value, index) {
                    if (value === $sanitize(value)) {
                        vm.errorMessage[index] = false;
                    }
                    else {
                        vm.errorMessage[index] = true;
                    }
                }
                vm.create = function () {
                    WizardHandler.wizard("formsWizard").finish();
                    $uibModalInstance.close(vm.buildRequest());
                }

                vm.nameExitValidation = function () {
                    if (!vm.updating) {
                        if (vm.pickedTemplate && vm.nameNameStepForm.$valid) {
                            return true;
                        }
                    }
                    else if (vm.updating) {
                        return vm.nameNameStepForm.$valid;
                    }
                    else {
                        return false;
                    }
                }

                vm.canEnterStepOne = function () {
                    return true;
                }

                vm.detailsExitValidation = function () {
                    if (Object.values(vm.errorMessage).includes(true)) {
                        return false;
                    }
                    else {
                        return vm.nameNameStepTwoForm.$valid;
                    }
                }

                vm.newForm = {
                    customisations: {}
                };
                vm.initialise = function () {
                    if (form) {

                        vm.updating = true;
                        vm.wizardTitle = "Update form";
                        vm.newForm.templateId = form.templateId;
                        vm.resources = form.resources;
                        vm.newForm.description = form.description;
                        vm.newForm.id = form.id;
                        vm.pickedTemplate = vm.formsTemplates.filter(obj => {
                            return obj.id === form.templateId
                        })[0];

                        vm.createPreview();
                    } else {
                        vm.wizardTitle = "Create form";
                    }
                }

                vm.buildRequest = function () {
                    var data = {
                        description: vm.newForm.description,
                        resources: vm.resources,
                        id: form ? form.id : undefined,
                        templateId: vm.newForm.templateId,
                    };
                    return data;

                }

                vm.initialise();

            }]);

})(window.angular);
